export function GetGoogleMapAPI(envVariableNameForGoogleMapAPI: string) {
  // Define a mapping object for environment variable names
  const envVariableMappings: Record<string, string> = {
    NEXT_PUBLIC_GLOBAL_SITE_GOOGLE_MAP_API_KEY:
      process.env.NEXT_PUBLIC_GLOBAL_SITE_GOOGLE_MAP_API_KEY || '',
    NEXT_PUBLIC_ADVOCATEHEALTHCOM_SITE_GOOGLE_MAP_API_KEY:
      process.env.NEXT_PUBLIC_ADVOCATEHEALTHCOM_SITE_GOOGLE_MAP_API_KEY || '',
    NEXT_PUBLIC_ADVOCATECHILDRENSHOSPITAL_SITE_GOOGLE_MAP_API_KEY:
      process.env.NEXT_PUBLIC_ADVOCATECHILDRENSHOSPITAL_SITE_GOOGLE_MAP_API_KEY || '',
    NEXT_PUBLIC_ADVOCATEHEALTHORG_SITE_GOOGLE_MAP_API_KEY:
      process.env.NEXT_PUBLIC_ADVOCATEHEALTHORG_SITE_GOOGLE_MAP_API_KEY || '',
    NEXT_PUBLIC_AURORAHEALTHCAREORG_SITE_GOOGLE_MAP_API_KEY:
      process.env.NEXT_PUBLIC_AURORAHEALTHCAREORG_SITE_GOOGLE_MAP_API_KEY || '',
    NEXT_PUBLIC_AURORABAYCARECOM_SITE_GOOGLE_MAP_API_KEY:
      process.env.NEXT_PUBLIC_AURORABAYCARECOM_SITE_GOOGLE_MAP_API_KEY || '',
    NEXT_PUBLIC_ATRIUMHEALTHFLOYDHARBINORG_SITE_GOOGLE_MAP_API_KEY:
      process.env.NEXT_PUBLIC_ATRIUMHEALTHFLOYDHARBINORG_SITE_GOOGLE_MAP_API_KEY || '',
  };

  // Return the value corresponding to the provided environment variable name
  return envVariableMappings[envVariableNameForGoogleMapAPI] || '';
}
